import { FormProvider, useForm } from "react-hook-form"
import { ProfilAssetType, profilValidation } from "../../utils"
import { FormSectionProfil } from "../FormSection"
import { useContext } from "react"
import { FormDataContext } from "../../context"
import { yupResolver } from "@hookform/resolvers/yup"
import toast from "react-hot-toast"
import { useApi } from "utils"
import { defaultValueProfil } from "../../utils/vars"

export function TabProfile() {
    const api = useApi()

    // context
    const { dataAsset, refecth, refecthUsage } = useContext(FormDataContext)
    

    // use form
    const method = useForm<ProfilAssetType>({
        defaultValues: defaultValueProfil(dataAsset ?? {}),
        resolver: yupResolver(profilValidation)
    })

    const onSubmit = (data: ProfilAssetType) => {

        const finalData = { ...data, asset_id: dataAsset?.asset_id }
        const formData = new FormData()

        Object.entries(finalData).forEach(([key, value]) => {
            formData.append(key, String(value));
        })

        const url = dataAsset?.asset_profile_id
            ? `/assetdepre/update_asset_profile?asset_profile_id=${dataAsset?.asset_profile_id}`
            : "/assetdepre/update_asset_profile";

        return new Promise<void>((resolve) => {
            toast.promise(
                api.put(url, formData),

                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.message ?? err.response.message
                }
            ).then(() => {

                refecth()
                refecthUsage()

                setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                }, 100);

            }).catch(() => { }).finally(resolve)
        })
    }

    

    return (
        <FormProvider {...method}>
            <FormSectionProfil onSubmit={method.handleSubmit(onSubmit)}/>
        </FormProvider>
    )
}